<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aC6bbX/tc-custom/9781504091664.jpg?1716663164211" alt="This image is the cover for the book Peril"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peril
      </h1>
      <p class="bookDescription body article font2">
        <b>A mobster sends his bagman to track down his runaway daughter-in-law in this novel by “one of the most accomplished writers in the crime/thriller genre” (<i>Financial Times</i>).</b><br/><br/> Sara Labriola is certain that if she stays in her marriage, someone is going to wind up dead—and it’ll probably be her. So she flees her coastal Long Island home for New York City, where she changes her identity and finds work singing at a bar.<br/><br/> Her husband is upset, of course. But her father-in-law, a small-time but brutal mob boss, is angry—and orders an underling to find her. . Meanwhile, Sara’s husband—who despises his cruel, controlling father—learns of his father’s plot and sends a friend into the mix to prevent the impending bloodshed. With multiple men searching for her, Sara is in danger. But she’s not the only one . . .<br/><br/> “Neat turns of phrase and tight plotting make for an engaging read.” —<i>Publishers Weekly</i><br/><br/> “Nobody tells a story better than Cook.” —Michael Connelly 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas H. Cook
      </h2>
      
      <p class="authorDescription body article"> THOMAS H. COOK was born in Fort Payne, Alabama. He has been nominated for Edgar Awards seven times in five different categories. He received the Best Novel Edgar, the Barry for Best Novel, and has been nominated for numerous other awards.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3666bfea